import { __decorate, __param } from 'tslib';
import { Inject, Input, HostBinding, Directive, NgModule } from '@angular/core';
import { TuiDirectiveStylesService, tuiDefaultProp } from '@taiga-ui/cdk';

/**
 * @deprecated use CSS custom properties
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/cdk';
const COLOR = `[data-tui-background='primary'] {
    background-color: var(--tui-primary);
}

[data-tui-background='secondary'] {
    background-color: var(--tui-info-fill);
}

[data-tui-background='success'] {
    background-color: var(--tui-success-fill);
}

[data-tui-background='error'] {
    background-color: var(--tui-error-fill);
}

[data-tui-background='support-mustard'],
[data-tui-background='support-01'] {
    background-color: var(--tui-support-01);
}

[data-tui-background='support-texas'],
[data-tui-background='support-02'] {
    background-color: var(--tui-support-02);
}

[data-tui-background='support-tan'],
[data-tui-background='support-03'] {
    background-color: var(--tui-support-03);
}

[data-tui-background='support-salmon'],
[data-tui-background='support-04'] {
    background-color: var(--tui-support-04);
}

[data-tui-background='support-sienna'],
[data-tui-background='support-05'] {
    background-color: var(--tui-support-05);
}

[data-tui-background='support-bittersweet'],
[data-tui-background='support-06'] {
    background-color: var(--tui-support-06);
}

[data-tui-background='support-pinkie'],
[data-tui-background='support-07'] {
    background-color: var(--tui-support-07);
}

[data-tui-background='support-charm'],
[data-tui-background='support-08'] {
    background-color: var(--tui-support-08);
}

[data-tui-background='support-amethyst'],
[data-tui-background='support-09'] {
    background-color: var(--tui-support-09);
}

[data-tui-background='support-helio'],
[data-tui-background='support-10'] {
    background-color: var(--tui-support-10);
}

[data-tui-background='support-lilac'],
[data-tui-background='support-11'] {
    background-color: var(--tui-support-11);
}

[data-tui-background='support-malibu'],
[data-tui-background='support-12'] {
    background-color: var(--tui-support-12);
}

[data-tui-background='support-havelock'],
[data-tui-background='support-13'] {
    background-color: var(--tui-support-13);
}

[data-tui-background='support-picton'],
[data-tui-background='support-14'] {
    background-color: var(--tui-support-14);
}

[data-tui-background='support-mint'],
[data-tui-background='support-15'] {
    background-color: var(--tui-support-15);
}

[data-tui-background='support-fountain'],
[data-tui-background='support-16'] {
    background-color: var(--tui-support-16);
}

[data-tui-background='support-puertorico'],
[data-tui-background='support-17'] {
    background-color: var(--tui-support-17);
}

[data-tui-background='support-bay'],
[data-tui-background='support-18'] {
    background-color: var(--tui-support-18);
}

[data-tui-background='support-forest'],
[data-tui-background='support-19'] {
    background-color: var(--tui-support-19);
}

[data-tui-background='support-york'],
[data-tui-background='support-20'] {
    background-color: var(--tui-support-20);
}

[data-tui-background='support-feijoa'],
[data-tui-background='support-21'] {
    background-color: var(--tui-support-21);
}

[data-tui-background='base-01'] {
    background-color: var(--tui-base-01);
}

[data-tui-background='base-02'] {
    background-color: var(--tui-base-02);
}

[data-tui-background='base-03'] {
    background-color: var(--tui-base-03);
}

[data-tui-background='base-04'] {
    background-color: var(--tui-base-04);
}

[data-tui-background='base-05'] {
    background-color: var(--tui-base-05);
}

[data-tui-background='base-06'] {
    background-color: var(--tui-base-06);
}

[data-tui-background='base-07'] {
    background-color: var(--tui-base-07);
}

[data-tui-background='base-08'] {
    background-color: var(--tui-base-08);
}

[data-tui-background='base-09'] {
    background-color: var(--tui-base-09);
}

[data-tui-color='primary'] {
    color: var(--tui-primary);
}

[data-tui-color='secondary'] {
    color: var(--tui-info-fill);
}

[data-tui-color='success'] {
    color: var(--tui-success-fill);
}

[data-tui-color='error'] {
    color: var(--tui-error-fill);
}

[data-tui-color='support-mustard'],
[data-tui-color='support-01'] {
    color: var(--tui-support-01);
}

[data-tui-color='support-texas'],
[data-tui-color='support-02'] {
    color: var(--tui-support-02);
}

[data-tui-color='support-tan'],
[data-tui-color='support-03'] {
    color: var(--tui-support-03);
}

[data-tui-color='support-salmon'],
[data-tui-color='support-04'] {
    color: var(--tui-support-04);
}

[data-tui-color='support-sienna'],
[data-tui-color='support-05'] {
    color: var(--tui-support-05);
}

[data-tui-color='support-bittersweet'],
[data-tui-color='support-06'] {
    color: var(--tui-support-06);
}

[data-tui-color='support-pinkie'],
[data-tui-color='support-07'] {
    color: var(--tui-support-07);
}

[data-tui-color='support-charm'],
[data-tui-color='support-08'] {
    color: var(--tui-support-08);
}

[data-tui-color='support-amethyst'],
[data-tui-color='support-09'] {
    color: var(--tui-support-09);
}

[data-tui-color='support-helio'],
[data-tui-color='support-10'] {
    color: var(--tui-support-10);
}

[data-tui-color='support-lilac'],
[data-tui-color='support-11'] {
    color: var(--tui-support-11);
}

[data-tui-color='support-malibu'],
[data-tui-color='support-12'] {
    color: var(--tui-support-12);
}

[data-tui-color='support-havelock'],
[data-tui-color='support-13'] {
    color: var(--tui-support-13);
}

[data-tui-color='support-picton'],
[data-tui-color='support-14'] {
    color: var(--tui-support-14);
}

[data-tui-color='support-mint'],
[data-tui-color='support-15'] {
    color: var(--tui-support-15);
}

[data-tui-color='support-fountain'],
[data-tui-color='support-16'] {
    color: var(--tui-support-16);
}

[data-tui-color='support-puertorico'],
[data-tui-color='support-17'] {
    color: var(--tui-support-17);
}

[data-tui-color='support-bay'],
[data-tui-color='support-18'] {
    color: var(--tui-support-18);
}

[data-tui-color='support-forest'],
[data-tui-color='support-19'] {
    color: var(--tui-support-19);
}

[data-tui-color='support-york'],
[data-tui-color='support-20'] {
    color: var(--tui-support-20);
}

[data-tui-color='support-feijoa'],
[data-tui-color='support-21'] {
    color: var(--tui-support-21);
}

[data-tui-color='base-01'] {
    color: var(--tui-base-01);
}

[data-tui-color='base-02'] {
    color: var(--tui-base-02);
}

[data-tui-color='base-03'] {
    color: var(--tui-base-03);
}

[data-tui-color='base-04'] {
    color: var(--tui-base-04);
}

[data-tui-color='base-05'] {
    color: var(--tui-base-05);
}

[data-tui-color='base-06'] {
    color: var(--tui-base-06);
}

[data-tui-color='base-07'] {
    color: var(--tui-base-07);
}

[data-tui-color='base-08'] {
    color: var(--tui-base-08);
}

[data-tui-color='base-09'] {
    color: var(--tui-base-09);
}
`;

/**
 * @deprecated use CSS custom properties
 */
let TuiColorDirective = class TuiColorDirective {
    constructor(directiveStyles) {
        this.tuiColor = '';
        this.tuiBackground = '';
        directiveStyles.addStyle(COLOR, 'TuiColorDirective');
    }
};
TuiColorDirective.ɵfac = function TuiColorDirective_Factory(t) { return new (t || TuiColorDirective)(ɵngcc0.ɵɵdirectiveInject(TuiDirectiveStylesService)); };
TuiColorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiColorDirective, selectors: [["", "tuiColor", ""], ["", "tuiBackground", ""]], hostVars: 2, hostBindings: function TuiColorDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-tui-color", ctx.tuiColor)("data-tui-background", ctx.tuiBackground);
    } }, inputs: { tuiColor: "tuiColor", tuiBackground: "tuiBackground" } });
TuiColorDirective.ctorParameters = () => [
    { type: TuiDirectiveStylesService, decorators: [{ type: Inject, args: [TuiDirectiveStylesService,] }] }
];
__decorate([
    Input(),
    HostBinding('attr.data-tui-color'),
    tuiDefaultProp()
], TuiColorDirective.prototype, "tuiColor", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-tui-background'),
    tuiDefaultProp()
], TuiColorDirective.prototype, "tuiBackground", void 0);
TuiColorDirective = __decorate([ __param(0, Inject(TuiDirectiveStylesService))
], TuiColorDirective);

/**
 * @deprecated use CSS custom properties
 */
let TuiColorModule = class TuiColorModule {
};
TuiColorModule.ɵfac = function TuiColorModule_Factory(t) { return new (t || TuiColorModule)(); };
TuiColorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiColorModule });
TuiColorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiColorDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiColor],[tuiBackground]'
            }]
    }], function () { return [{ type: ɵngcc1.TuiDirectiveStylesService, decorators: [{
                type: Inject,
                args: [TuiDirectiveStylesService]
            }] }]; }, { tuiColor: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-tui-color']
        }], tuiBackground: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-tui-background']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiColorModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiColorDirective],
                exports: [TuiColorDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiColorModule, { declarations: [TuiColorDirective], exports: [TuiColorDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { COLOR, TuiColorDirective, TuiColorModule };

